import React from "react";

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  <img src="/assets/images/bouncing_circles.svg" alt="bouncing_circles"/>
</div>;
export default CircularProgress;
